/**
 * © 2026 Madar.iq — جميع الحقوق محفوظة
 * هذا الملف جزء من منظومة Madar.iq البرمجية.
 * يُحظر نسخه أو تعديله أو توزيعه دون إذن كتابي.
 * All Rights Reserved — Unauthorized use is prohibited.
 */
import React, { useState } from "react";
import { FiX, FiStar, FiMessageSquare, FiSend } from "react-icons/fi";

export default function ReviewModal({
  show,
  onClose,
  tenantId,
  newReview,
  setNewReview,
  addStoreReview,
  getStoreReviews,
  setStoreReviews,
  theme // مررنا الثيم هنا لتوحيد الألوان
}) {
  const [hoverRating, setHoverRating] = useState(0);

  if (!show) return null;

  const handleSubmit = async () => {
    const customer = JSON.parse(localStorage.getItem("storeCustomer"));

    const res = await addStoreReview({
      tenantId,
      customerName: customer?.customerName || customer?.name || "عميل",
      rating: Number(newReview.rating),
      description: newReview.description
    });

    if (res?.success || res) {
      onClose();
      setNewReview({ rating: 5, description: "" });

      // تحديث القائمة
      const updated = await getStoreReviews(tenantId);
      if (updated.success) {
        setStoreReviews(updated.data.filter(r => r.isActive === 1));
      }
    }
  };

  return (
    <div className="fixed inset-0 z-[40000] bg-black/60 backdrop-blur-sm flex items-stretch justify-center p-0 animate-fadeIn" dir="rtl">
      <div className="bg-white w-full h-full max-h-none max-w-none rounded-none shadow-2xl overflow-hidden flex flex-col">

        {/* Header */}
        <div className="flex items-center justify-between px-8 py-6 border-b border-gray-50">
          <div className="flex items-center gap-3">
            <div className={`${theme.bg} p-2.5 rounded-xl text-white`}>
              <FiStar size={20} />
            </div>
            <h3 className="text-xl font-black text-gray-800">تقييم المتجر</h3>
          </div>
          <button
            onClick={onClose}
            className="w-10 h-10 flex items-center justify-center rounded-full bg-gray-50 text-gray-400 hover:bg-red-50 hover:text-red-500 transition-all"
          >
            <FiX size={24} />
          </button>
        </div>

        <div className="p-8 space-y-8">
          {/* Star Selection */}
          <div className="flex flex-col items-center gap-4">
            <p className="font-bold text-gray-600 text-sm italic">كيف كانت تجربتك معنا؟</p>
            <div className="flex gap-2">
              {[1, 2, 3, 4, 5].map((star) => (
                <button
                  key={star}
                  onMouseEnter={() => setHoverRating(star)}
                  onMouseLeave={() => setHoverRating(0)}
                  onClick={() => setNewReview({ ...newReview, rating: star })}
                  className="transition-all transform hover:scale-125 active:scale-90"
                >
                  <FiStar
                    size={36}
                    className={`transition-colors ${star <= (hoverRating || newReview.rating)
                        ? "fill-yellow-400 text-yellow-400"
                        : "text-gray-200"
                      }`}
                  />
                </button>
              ))}
            </div>
          </div>

          {/* Feedback Textarea */}
          <div className="space-y-3">
            <label className="flex items-center gap-2 text-sm font-bold text-gray-500 mr-2">
              <FiMessageSquare size={16} />
              رأيك يهمنا
            </label>
            <textarea
              placeholder="اكتب ملاحظاتك هنا..."
              value={newReview.description}
              onChange={(e) => setNewReview({ ...newReview, description: e.target.value })}
              className="w-full h-32 p-5 bg-gray-50 border border-gray-100 rounded-[1.5rem] text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500/10 focus:bg-white transition-all resize-none"
            />
          </div>

          {/* Action Buttons */}
          <div className="flex gap-3">
            <button
              onClick={handleSubmit}
              className={`flex-1 h-14 rounded-2xl ${theme.bg} text-white font-bold flex items-center justify-center gap-2 hover:opacity-90 shadow-lg shadow-indigo-100 transition-all active:scale-95`}
            >
              <FiSend size={18} />
              إرسال التقييم
            </button>
            <button
              onClick={onClose}
              className="px-6 h-14 rounded-2xl bg-gray-100 text-gray-500 font-bold hover:bg-gray-200 transition-all"
            >
              إلغاء
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
